module.exports = __webpack_public_path__ + "static/media/icon_sidebar_onboarding.30d0977f.svg";